export default [
  {
    path: 'articleManage',
    name: {list:['产业门户','文章','文章管理','管理文章'],"portalType":"induDoor"},
    component: () => import('@/views/article/articleManage.vue')
  },
  {
    path: 'articleAdd',
    name: {list:['产业门户','文章','文章管理','添加文章'],"portalType":"induDoor"},
    component: () => import('@/views/article/articleAdd.vue')
  },
  {
    path: 'articleClassifi',
    name: {list:['产业门户','文章','文章管理','文章分类'],"portalType":"induDoor"},
    component: () => import('@/views/article/articleClassifi.vue')
  },
  {
    path: 'articleExamM',
    name: {list:['产业门户','文章','文章审核','文章审核'],"portalType":"induDoor"},
    component: () => import('@/views/article/articleExamM.vue')
  },
  {
    path: 'articleExam',
    name: {list:['产业门户','文章','文章审核','文章审核'],"portalType":"induDoor",title:'文章审核'},
    component: () => import('@/views/article/articleExam.vue')
  },
  {
    path: 'articlePz',
    name: {list:['产业门户','文章','文章审核','文章配置'],"portalType":"induDoor"},
    component: () => import('@/views/article/articlePz.vue')
  },

  
{
  path: 'qqtarticleManage',
  name: {list:['全球商通中心','文章','文章管理','管理文章'],"portalType":"nfstzx"},
  component: () => import('@/views/article/articleManage.vue')
},
{
  path: 'qqtarticleAdd',
  name: {list:['全球商通中心','文章','文章管理','添加文章'],"portalType":"nfstzx"},
  component: () => import('@/views/article/articleAdd.vue')
},
{
  path: 'qqtarticleClassifi',
  name: {list:['全球商通中心','文章','文章管理','文章分类'],"portalType":"nfstzx"},
  component: () => import('@/views/article/articleClassifi.vue')
},
{
  path: 'qqtarticleExamM',
  name: {list:['全球商通中心','文章','文章审核','文章审核'],"portalType":"nfstzx"},
  component: () => import('@/views/article/articleExamM.vue')
},
{
  path: 'qqtarticleExam',
  name: {list:['全球商通中心','文章','文章审核','文章审核'],"portalType":"nfstzx",title:'文章审核'},
  component: () => import('@/views/article/articleExam.vue')
},
{
  path: 'qqtarticlePz',
  name: {list:['全球商通中心','文章','文章审核','文章配置'],"portalType":"nfstzx"},
  component: () => import('@/views/article/articlePz.vue')
},


{
  path: 'columnManage',
  name: {list:['产业门户','门户','栏目管理','栏目管理'],projectType:'induDoor'},
  component: () => import('@/views/portal/columnManage.vue')
},
{
  path: 'navigationManage',
  name: {list:['产业门户','门户','栏目管理','导航管理']},
  component: () => import('@/views/portal/navigationManage.vue')
},{
  path: 'baseMoudle',
  name: {list:['产业门户','门户','内容管理','内容管理']},
  component: () => import('@/views/portal/baseMoudle.vue')
},{
  path: 'moduleAdd',
  name: {list:['产业门户','门户','内容管理','内容管理','添加模块内容'],title:'添加模块内容',"portalType":null},
  component: () => import('@/views/portal/moduleEdit.vue')
},{
  path: 'moduleEdit',
  name: {list:['产业门户','门户','内容管理','内容管理','编辑模块内容'],title:'编辑模块内容',"portalType":null},
  component: () => import('@/views/portal/moduleEdit.vue')
},{
  path: 'aboutusAdd',
  name: {list:['产业门户','门户','内容管理','关于我们','添加模块内容'],title:'添加模块内容',"portalType":null},
  component: () => import('@/views/portal/moduleEdit.vue')
},{
  path: 'qqtmoduleAdd',
  name: {list:['全球商通中心','门户','基础配置','关于我们'],title:'添加模块内容',"portalType":"nfstzx"},
  component: () => import('@/views/portal/moduleEdit.vue')
},{
  path: 'qqtmoduleEdit',
  name: {list:['全球商通中心','门户','基础配置','关于我们'],title:'编辑模块内容',"portalType":"nfstzx"},
  component: () => import('@/views/portal/moduleEdit.vue')
},{
  path: 'basicConfig',
  name: {list:['产业门户','门户','内容管理','基础信息'],"portalType":null},
  component: () => import('@/views/portal/basicConfig.vue')
},{
  path: 'qqtbasicConfig',
  name: {list:['全球商通中心','门户','基础配置','基础信息'],"portalType":"nfstzx"},
  component: () => import('@/views/portal/basicConfig.vue')
},{
  path: 'link',
  name: {list:['产业门户','门户','内容管理','友情链接'],"portalType":null},
  component: () => import('@/views/portal/link.vue')
},{
  path: 'qqtlink',
  name: {list:['全球商通中心','门户','基础配置','友情链接'],"portalType":"nfstzx"},
  component: () => import('@/views/portal/link.vue')
},{
  path: 'configurationShare',
  name: {list:['产业门户','门户','门户推广','门户推广']},
  component: () => import('@/views/portal/configurationShare.vue')
},{
  path: 'aboutUs',
  name: {list:['产业门户','门户','内容管理','关于我们']},
  component: () => import('@/views/portal/aboutUs.vue') 
},{
  path: 'qqtaboutUs',
  name: {list:['全球商通中心','门户','基础配置','关于我们'],"portalType":"nfstzx"},
  component: () => import('@/views/portal/aboutUs.vue') 
},{
  path: 'chinaMedicine',
  name: {list:['产业门户','门户','内容管理','品种名录']},
  component: () => import('@/views/portal/chinaMedicine.vue') 
},{
  path: 'addChinaMedicine',
  name: {list:['产业门户','门户','内容管理','品种名录'],title:"添加品种"},
  component: () => import('@/views/portal/addChinaMedicine.vue') 
},{
  path: 'qualifications',
  name: {list:['系统管理','门户','内容管理','商务资质'],projectType:'induDoor'},
  component: () => import('@/views/portal/qualifications.vue') 
},
{
  path: 'role',
  name: {list:['系统设置','设置','组织架构','角色管理']},
  component: () => import('@/views/setUp/role.vue')
},
{
  path: 'roleEdit',
  name: {list:['系统设置','设置','组织架构','角色管理','添加角色'],title:'添加角色'},
  component: () => import('@/views/setUp/roleEdit.vue')
},
{
  path: 'staff',
  name: {list:['系统设置','设置','组织架构','员工管理']},
  component: () => import('@/views/setUp/staff.vue')
},
{
  path: 'staffEdit',
  name: {list:['系统设置','设置','组织架构','员工管理','添加员工'],title:'添加员工'},
  component: () => import('@/views/setUp/staffEdit.vue')
},
{
  path: 'termSet',
  name: {list:['系统设置','设置','系统配置','期限设置',]},
  component: () => import('@/views/setUp/termSet.vue')
},
{
  path: 'security',
  name: {list:['系统设置','设置','基本信息','账户安全'],title:'账户安全'},
  component: () => import('@/views/setUp/security.vue')
},
{
  path: 'platInfoManage',
  name: {list:['系统设置','设置','基本信息','平台信息'],title:'平台信息'},
  component: () => import('@/views/setUp/platInfoManage.vue')
},
{
  path: 'platInfoSet',
  name: {list:['系统设置','设置','基本信息','平台配置'],title:'平台配置'},
  component: () => import('@/views/setUp/platInfoSet.vue')
},
{
  path: 'platInfoSetEdit',
  name: {list:['系统设置','设置','基本信息','平台配置'],title:'平台配置'},
  component: () => import('@/views/setUp/platInfoSetEdit.vue')
},
{
  path: 'csTeam',
  name: {list:['系统设置','设置','客服设置','客服团队管理'],title:'客服团队管理'},
  component: () => import('@/views/setUp/csTeam.vue')
},
{
  path: 'csTeamEdit',
  name: {list:['系统设置','设置','客服设置','客服团队管理'],title:'编辑客服团队'},
  component: () => import('@/views/setUp/csTeamEdit.vue')
},
{
  path: 'csTeamAdd',
  name: {list:['系统设置','设置','客服设置','客服团队管理'],title:'添加客服团队'},
  component: () => import('@/views/setUp/csTeamEdit.vue')
},
{
  path: 'protocolConfig',
  name: {list:['全球商通中心','门户','基础配置','协议配置'],projectType:'nfstzx'},
  component: () => import('@/views/setUp/protocolConfig.vue')
},
{
  path: 'protocolConfigAdd',
  name: {list:['全球商通中心','门户','基础配置','协议配置'],title:'添加协议'},
  component: () => import('@/views/setUp/protocolConfigEdit.vue')
},
{
  path: 'protocolConfigEdit',
  name: {list:['全球商通中心','门户','基础配置','协议配置'],title:'编辑协议'},
  component: () => import('@/views/setUp/protocolConfigEdit.vue')
},
{
  path: 'qualificationsQqst',
  name: {list:['全球商通中心','门户','基础配置','底部信息'],projectType:'nfstzx'},
  component: () => import('@/views/portal/qualifications.vue') 
},
{
  path: 'columnManageQqst',
  name: {list:['全球商通中心','门户','栏目配置','栏目管理'],projectType:'nfstzx'},
  component: () => import('@/views/portal/columnManageNew.vue')
},
]